import { combineReducers } from 'redux';

import filingGroupsReducer from '../filingGroups/store/reducer';
import manualAdjustmentReportReducer from '../manualAdjustmentReport/store/reducer';

export default combineReducers({
  filingGroups: filingGroupsReducer,
  manualAdjustmentReport: manualAdjustmentReportReducer,
});
